export const GRAPHQL_URL =
  process.env.REACT_APP_ENVIRONMENT === 'local' ? process.env.REACT_APP_GRAPHQL_BFF_URL_DEV : process.env.REACT_APP_GRAPHQL_BFF_URL_PROD;
export const BFF_URL = process.env.REACT_APP_ENVIRONMENT === 'local' ? process.env.REACT_APP_BFF_URL_DEV : process.env.REACT_APP_BFF_URL_PROD;
